import { render, staticRenderFns } from "./colorFilter.vue?vue&type=template&id=740145c8&scoped=true"
import script from "./colorFilter.vue?vue&type=script&lang=js"
export * from "./colorFilter.vue?vue&type=script&lang=js"
import style0 from "./colorFilter.vue?vue&type=style&index=0&id=740145c8&prod&lang=scss&scoped=true"
import style1 from "./colorFilter.vue?vue&type=style&index=1&id=740145c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740145c8",
  null
  
)

export default component.exports